import { Enumify } from "enumify";

class Sort extends Enumify {
  static wdate = new Sort({
    name : "등록순",
    descSort : 'DESC',
    ascSort : 'ASC'
  });
  static acount = new Sort({
    name : "인기순",
    descSort : 'DESC',
    ascSort : 'ASC'
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default Sort;
